import Vue from "vue";
import axios from "axios";

import Modal from "../vue/components/Modal.vue";
export default {
  init() {
    new Vue({
      components: { Modal },
      el: ".buy-property-form",
      data() {
        return {
          isLoading: false,
          openModal: false,
          form: {
            property_type: "",
          },
        };
      },

      methods: {
        submit() {
          const form = document.querySelector(".buy-property-form form");

          if (!form.checkValidity()) {
            form.classList.add("was-validated");
          } else {
            this.isLoading = true;

            axios
              .post(`${LTM.api.url}v1/buy-property`, this.form)
              .then(({ data }) => {
                this.openModal = true;
                this.form = {};
              })
              .catch((error) => { })
              .then(() => {
                this.isLoading = false;
              });
          }
        },
      },
    });
  },
  finalize() { },
};
